import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const IconHtml = (props) => (
  <SvgIcon
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 482.139 482.139"
    style={{ enableBackground: "new 0 0 482.139 482.139" }}
    {...props}
  >
    <path
      d="M315.459,0H121.812c-28.29,0-51.315,23.041-51.315,51.314v189.755h-5.013c-11.418,0-20.677,9.251-20.677,20.679v125.404
	c0,11.426,9.259,20.677,20.677,20.677h5.013v22.994c0,28.306,23.025,51.315,51.315,51.315h264.221c28.275,0,51.3-23.01,51.3-51.315
	V121.449L315.459,0z M67.194,364.757v-76.185h17.304v29.281h28.37v-29.281h17.178v76.185h-17.178V332.89h-28.37v31.867H67.194z
	 M386.032,450.713H121.812c-10.955,0-19.874-8.92-19.874-19.89v-22.994h246.302c11.418,0,20.679-9.251,20.679-20.677V261.748
	c0-11.428-9.261-20.679-20.679-20.679H101.938V51.314c0-10.937,8.919-19.857,19.874-19.857l181.89-0.189v67.233
	c0,19.638,15.934,35.587,35.585,35.587l65.863-0.189l0.74,296.924C405.891,441.793,396.986,450.713,386.032,450.713z
	 M139.282,303.038v-14.466h58.549v14.466h-20.804v61.719h-17.29v-61.719H139.282z M204.796,364.757l4.855-76.185h22.948
	l7.454,25.436c2.38,8.811,4.759,18.314,6.446,27.233h0.347c2.143-8.81,4.744-18.864,7.234-27.343l8.133-25.326h22.489l4.193,76.185
	h-16.849l-1.135-29.157c-0.33-9.157-0.678-20.236-0.678-31.315h-0.331c-2.379,9.724-5.547,20.567-8.479,29.503l-9.267,29.725
	h-13.459l-8.132-29.504c-2.491-8.92-5.09-19.779-6.903-29.724h-0.221c-0.457,10.292-0.788,22.048-1.355,31.536l-1.355,28.936
	H204.796z M349.649,350.289v14.468h-47.596v-76.185h17.306v61.717H349.649z"
    />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </SvgIcon>
);

export default IconHtml;
